export default {
    cta: "Pergunte a um<br/> Orientador",
    ordered: "Encomendado em {date}"
}